export default "__VITE_ASSET__HIku0N$v__"